import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-circle",
  "use": "icon-si-glyph-circle-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-circle\" id=\"icon-si-glyph-circle\"><title>1243</title><defs class=\"si-glyph-fill\"></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" class=\"si-glyph-fill\"><circle fill=\"#434343\" cx=\"9\" cy=\"9\" r=\"8\" class=\"si-glyph-fill\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-circle.svg
// module id = IjQy
// module chunks = 62